import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import {
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {OccasionalService} from "../../../serverService/occasional/OccasionalService";
import {useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function AddNewOccasionalBanner({handleAddNewItem,handleCloseDialog}) {

    const service = new OccasionalService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [title, setTitle] = useState("")
    const [slug, setSlug] = useState("")
    const [priority, setPriority] = useState(1)

    function handleAddNewOccasionalBanner() {
        loading.show()
        service.createNewBanner(title, slug, priority)
            .then(response => {
                showSuccessMessage("بنر جدید با موفقیت افزوده شد.")
                handleAddNewItem(response)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن بنر مناسبتی جدید"}
                hasActionButton
                actionButtonTitle={"افزودن"}
                actionButtonOnclickWithValidation={handleAddNewOccasionalBanner}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleCloseDialog}
            >
                <RaikoSimpleInputOutlined
                    labelText={"عنوان بنر مناسبتی"}
                    setValue={setTitle}
                    value={title}
                    required
                />
                <RaikoSimpleInputOutlined
                    labelText={"slug"}
                    setValue={setSlug}
                    value={slug}
                    required
                />
                <RaikoNumberInputOutlined
                    labelText={"اولویت"}
                    setValue={setPriority}
                    value={priority}
                    required
                />
            </RaikoSectionContainer>
        </RaikoBaseDialogContentContainer>
    )
}